import React, {useState} from 'react';
import {connect} from 'react-redux';
import {setLoginDetails} from '../../EsimUpgradeBlockSlice';
import {checkUserAfterLoginAsync} from '../../EsimUpgradeBlockAsyncThunk';
import Popup from '../../../../Shared/Popup/PopUp';
import IdValidationPopup from '../../../OTPLoginBlock/Popups/idValidationPopup';
import Config from '../../../../../Config';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';

const IdentityValidationPage = (props) => {
  const [isDisplayPopup, setIsDisplayPopup] = useState(true);

  return (
    <Popup showPopUp={isDisplayPopup} className='idValidationPopup' onClose={() => closeModal()} style={{background: 'white'}}>
      <IdValidationPopup setShowPopUp={setIsDisplayPopup} closeModal={handleCloseModal} />
    </Popup>
  );

  function closeModal() {
    setIsDisplayPopup(false);
    if (window.history.length > 1) {
      window.history.go(-1);
    } else {
      buildUrlAndOpenSameWindow(Config.lobbyUrl);
    }
  }

  function handleCloseModal() {
    const phoneNumber = props.authentication.loginData?.userDetails?.contactNumber;
    props.setLoginDetails({subscriberNo: phoneNumber});
    props.checkUserAfterLoginAsync({isDisplayLoader: true});
  }
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  setLoginDetails,
  checkUserAfterLoginAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdentityValidationPage);
